module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074d2_logo_200x200.2fe9c5fd.png";